<template>
    <div class="other_view_main">
        <div class="other_top"></div>
        <div class="other_bottom">
            <div class="bottom_left_info">
                <div class="left_menu">
                    <div class="menu_logo">经营项目</div>
                    <div class="menu_list">
                        <div class="menu_item" v-for="(item, i) in leftMenuList" :key="i" @click="selectMenuI = i"
                            :style="{
                                background: selectMenuI === i ? '#619533' : '#eee',
                                color: selectMenuI === i ? '#fff' : '#000',
                            }">
                            <div class="menu_item_icon" :style="{ color: selectMenuI === i ? '#fff' : '#619533', }"><i
                                    class="el-icon-caret-right"></i></div>
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="menu_footer">
                        <div class="footer_logo"></div>
                        <div class="footer_text1">
                            {{ infoJson.companyInfo.name }}
                        </div>
                        <div class="footer_text2">
                            地址：{{ infoJson.companyInfo.address }}
                        </div>
                        <div class="footer_text2">
                            电话：{{ infoJson.companyInfo.phone }}
                        </div>
                        <div class="footer_text2">
                            传真：{{ infoJson.companyInfo.fax }}
                        </div>
                        <div class="footer_text2">
                            邮箱：{{ infoJson.companyInfo.email }}
                        </div>
                        <div class="footer_text3">
                            “守合同重信用”企业
                        </div>
                        <div class="footer_text4">
                            亘利建筑咨询电话：
                        </div>
                        <div class="footer_text5">
                            {{ infoJson.companyInfo.phone }}
                        </div>
                    </div>
                </div>
                <div class="right_info"></div>
            </div>
            <div class="bottom_right_content">
                <div class="right_top_title">
                    {{ leftMenuList[selectMenuI].name }}
                    <div class="right_bottom_hen"></div>
                </div>
                <div class="right_bottom_content">
                    <template v-if="selectMenuI == 0">
                        <div v-html="leftMenuList[selectMenuI].desc"></div>
                    </template>
                    <template v-if="selectMenuI == 1">
                        <img src="@/assets/map.png" width="100%" height="100%" alt="">
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import infoJson from "@/utils/info.json";
export default {
    components: {},
    data() {
        return {
            infoJson,
            selectMenuI: 0,
            leftMenuList: [
                { name: "联系方式", url: "", desc: `地址：${infoJson.companyInfo.address}<br>电话：${infoJson.companyInfo.phone}<br>传真：${infoJson.companyInfo.fax}<br>邮箱：${infoJson.companyInfo.email}<br><img style="margin-top:10px; width:100%;"  src="http://www.nxhnjz.com/user_tm/bjq2/attached/image/20180726/20180726114663476347.jpg"/>` },
                { name: "电子地图", url: "", },
            ],
        };
    },
    methods: {
        requireImg(img) {
            return require(`@/assets${img.url}`);
        },
    }
}
</script>
<style lang="scss" scoped>
.other_view_main {
    .other_top {
        background-image: url(@/assets/other/other_bg.jpg);
        width: 100%;
        height: 380px;
    }

    .other_bottom {
        padding: 20px 15%;
        width: 70%;
        min-height: 400px;
        display: flex;
        background: #eee;

        .bottom_left_info {
            background: #fff;
            width: 281px;
            padding: 20px;
            min-height: 300px;

            .left_menu {
                width: 100%;

                .menu_footer {
                    margin-top: 40px;
                    color: rgba(0, 0, 0, 0.8);

                    .footer_text3 {
                        text-align: center;
                        font-size: 26px;
                        margin: 10px 0;
                        color: rgba(0, 0, 0, 0.7);
                    }

                    .footer_text5 {
                        color: #ff7e00;
                        font-size: 30px;
                        font-weight: bold;
                    }

                    .footer_text4 {
                        font-weight: 400;
                        font-size: 14px;
                    }

                    .footer_text2 {

                        font-weight: 400;
                        font-size: 14px;
                    }

                    .footer_text1 {
                        margin-bottom: 10px;
                        font-weight: 500;
                        font-size: 18px;
                    }

                    .footer_logo {
                        background-image: url(@/assets/other/contact_logo.jpg);
                        width: 201px;
                        height: 106px;
                        line-height: 90px;
                        font-size: 24px;
                        color: #fff;
                        font-weight: 600;
                        padding-left: 40px;
                    }
                }

                .menu_list {
                    .menu_item {
                        height: 50px;
                        width: 241px;
                        background: #eee;
                        text-align: center;
                        line-height: 50px;
                        margin-top: 1px;
                        cursor: pointer;
                        font-size: 16px;
                        position: relative;

                        .menu_item_icon {
                            color: #619533;
                            position: absolute;
                            left: 30px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }

                .menu_logo {
                    background-image: url(@/assets/other/other_logo.png);
                    width: 201px;
                    height: 106px;
                    line-height: 90px;
                    font-size: 24px;
                    color: #fff;
                    font-weight: 600;
                    padding-left: 40px;
                }
            }
        }

        .bottom_right_content {
            background: #fff;
            width: calc(100% - 281px);
            padding: 20px;
            min-height: 300px;

            .right_bottom_content {

                margin-top: 20px;
                line-height: 30px;

                .content_desc {
                    text-indent: 2em;
                }

                .qualification_list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    width: 100%;

                    .qualification_item {
                        width: calc(100% / 3 - 20px);
                        text-align: center;
                        cursor: pointer;

                        .qualification_name {
                            margin-top: 10px;
                            font-size: 12px;
                            color: rgba(0, 0, 0, 0.8);
                            font-weight: 500;
                            text-align: center;
                        }

                        img {
                            height: 150px;
                        }

                        &:hover {
                            .qualification_name {
                                color: #619533;
                            }
                        }
                    }
                }
            }

            .right_top_title {
                height: 40px;
                border-bottom: 2px solid #eee;
                color: #619533;
                font-size: 18px;
                font-weight: bold;
                text-align: left;
                padding-left: 15px;
                position: relative;

                .right_bottom_hen {
                    height: 2px;
                    border-bottom: 2px solid #619533;
                    font-size: 18px;
                    width: 120px;
                    left: 0;
                    bottom: -2px;
                    position: absolute;
                    z-index: 999;
                }
            }
        }
    }


}
</style>